import JobDetail2Container from "../../../components/job/detail/JobDetail2";

const JobDetail2 = () => {
  return <JobDetail2Container />;
};

export default JobDetail2;
